import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  getCategoryList,
  getProductList,
  getProductTypeList,
} from "../../Admin/adminSlice";
import moment from "moment";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import AdminTable from "../../../Component/adminTable";
import { getCouponTypeList, getSourceWiseAnalysis } from "../cxoSlice";
import BarChart from "./barchart";
import DatePicker from "../../../Component/datePicker";
import { hideSnackbar, showSnackbar } from "../../../store/slices/snackbarSlice";

const SourceWiseAnalysis = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productList, setProductList] = useState<any>([]);
  const [product, setProduct] = useState<any>("");
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [paymentType, setPaymentType] = useState<any>("");
  const [couponType, setCouponType] = useState<any>("");
  const [srcWiseAnalysisList, setSrcWiseAnalysisList] = useState<any>([]);
  const [xLabel1, setxLabel1] = useState<any>([]);
  const [Graphdata1, setGraphdata1] = useState<any>([]);
  const [couponTypeList, setCouponTypeList] = useState<any>([]);
  const [totalSourceWiseAmount, setTotalSourceWiseAmount] = useState<any>(0);
  const [paymentTypeList, setPaymentTypeList] = useState<any>([]);


  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
    dispatch(
      getCouponTypeList({
        callback: (res: any) => {
          setCouponTypeList(res?.data);
          const newArrr = res?.data
          const newItem = {
            _id: 5,
            name: "Without Coupon",
          };
          newArrr.unshift(newItem);
          setPaymentTypeList(newArrr);
        },
        errorCallback: () => { },
      })
    );
  }, [dispatch]);

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
    const postData = {
      productTypeId: productType?._id,
      categoryId: value?._id,
    };
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };

  const onchangeProduct = (value: any) => {
    setProduct(value);
  };
  const onchangePaymentType = (value: any) => {
    setPaymentType(value);
  };

  const onchangeCouponType = (value: any) => {
    setCouponType(value);
  };

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      startDate: startDate,
      endDate: endDate,
      productTypeId: productType?._id,
      categoryId: category?._id,
      productId: product?._id,
      paymentType: paymentType?._id,
      couponTypeId: couponType?._id,
    };
    if (
      postData["productTypeId"] === null ||
      postData["productTypeId"] === undefined ||
      postData["productTypeId"] === ""
    ) {
      delete postData["productTypeId"];
    }
    if (
      postData["categoryId"] === null ||
      postData["categoryId"] === undefined ||
      postData["categoryId"] === ""
    ) {
      delete postData["categoryId"];
    }
    if (
      postData["productId"] === null ||
      postData["productId"] === undefined ||
      postData["productId"] === ""
    ) {
      delete postData["productId"];
    }
    if (
      postData["paymentType"] === null ||
      postData["paymentType"] === undefined ||
      postData["paymentType"] === ""
    ) {
      delete postData["paymentType"];
    }
    if (
      postData["couponTypeId"] === null ||
      postData["couponTypeId"] === undefined ||
      postData["couponTypeId"] === ""
    ) {
      delete postData["couponTypeId"];
    }
    dispatch(
      getSourceWiseAnalysis({
        params: postData,
        callback: (res: any) => {
          setSrcWiseAnalysisList(res?.data?.dataWithContribution);
          setTotalSourceWiseAmount(res?.data?.OverAllContribution);
          xLabel1.length = 0;
          Graphdata1.length = 0;
          res?.data?.dataWithContribution?.map((value: any) => {
            xLabel1?.push(value?._id);
            Graphdata1?.push(value?.totalOfferPrice);
          });
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }))
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    let valid = false;
    if (startDate === "" || endDate === "") {
      valid = true;
    }
    return valid;
  };

  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={srcWiseAnalysisList ? srcWiseAnalysisList : []}
          pagename={"sourceWiseAnalysis"}
          tableHead={[
            "S.N",
            "Source",
            "Actual Revenue",
            "Total Revenue",
            "Overall Contribution",
          ]}
        />
      </div>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"SOURCE WISE ANALYSIS"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Category"} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product List"} />
                <DropdownWithClear
                  labelName={"Select Product List "}
                  setInputText={(value: any) => onchangeProduct(value)}
                  options={productList}
                  value={product}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Payment Type"} />
                <DropdownWithClear
                  labelName={"Select Payment Type "}
                  setInputText={(value: any) => onchangePaymentType(value)}
                  options={paymentTypeList}
                  value={paymentType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Coupon Type"} />
                <DropdownWithClear
                  labelName={"Select Coupon Type"}
                  setInputText={(value: any) => onchangeCouponType(value)}
                  options={couponTypeList}
                  value={couponType}
                />
              </div>
              <div className="col-md-4 mt-3">
                <div className="col-md-4 pt-2">
                  <Submitbtn name={"Submit"} disabled={validations()} />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="bxshadow borderRadius mb-3 p-2">
          <div className="col-md-12 mt-5">
            <BarChart label={xLabel1} value={Graphdata1} />
          </div>
          <div>
            <div className="d-flex align-items-center mt-5">
              <h5>
                Total Revenue: {"\u20B9"}
                {totalSourceWiseAmount?.toFixed(2)}
              </h5>
            </div>
          </div>
        </div>
        <div className="bxshadow borderRadius mb-3 p-1">
          <div className="mt-4">{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default SourceWiseAnalysis;
